import skrollr from 'skrollr';

export function parallax() {

    if (document.querySelector('.js-parallax')) {
        skrollr.init({ forceHeight: false });
    }

}